import { z } from 'zod';

import { IdSchema } from '../../base';
import {
  EntityConfigSchema,
  EntityDescriptionSchema,
  EntityNameSchema,
  EntityReferencesSchema,
  EntityTypeEnums,
} from './entities.schema';

export const CreateEntitySchema = z
  .object({
    id: IdSchema,
    name: EntityNameSchema,
    description: EntityDescriptionSchema,
    type: EntityTypeEnums,
    references: EntityReferencesSchema,
    config: EntityConfigSchema.optional(),
  })
  .describe(
    'Create a new entity to collect structured data from users during conversation',
  );

export const UpdateEntitySchema = z
  .object({
    id: IdSchema,
    name: EntityNameSchema.optional(),
    description: EntityDescriptionSchema.optional(),
    type: EntityTypeEnums.optional(),
    references: EntityReferencesSchema.optional(),
    config: EntityConfigSchema.optional(),
  })
  .describe("Update an entity's properties");

export const DeleteEntitySchema = z
  .object({
    id: IdSchema,
  })
  .describe('Delete an entity by its ID');

export type CreateEntityPayload = z.infer<typeof CreateEntitySchema>;
export type UpdateEntityPayload = z.infer<typeof UpdateEntitySchema>;
export type DeleteEntityPayload = z.infer<typeof DeleteEntitySchema>;
